import React from 'react'

import OrderBy from 'common/OrderBy.js'

export default (props) => {
    const prefix = 'vrtl-holding-card'
    return (
        <OrderBy.bar {...props}>
            <OrderBy.filter field='name' className={`${prefix}__section`}>
                Investor Name
            </OrderBy.filter>
            <OrderBy.sort date field='amount' className={`${prefix}__section`}>
                Amount
            </OrderBy.sort>
        </OrderBy.bar>
    )
}
